import React, { useState } from "react";
import { Menu, MenuItem, MenuButton } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import { colors } from "../../utils";

const IyugaMenu = ({ children, options, selected, onSelect }) => {
  return (
    <Menu
      menuStyle={{
        border: "1px solid #ddd", // Light gray border
        borderRadius: "8px", // Rounded corners
        padding: "8px 8px", // Space inside the menu
        background: "white",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Soft shadow
        gap: "10px",
      }}
      gap={10}
      menuButton={
        <MenuButton style={{ background: "transparent", border: "none" }}>
          {children}
        </MenuButton>
      }
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          onClick={() => onSelect(option.value)}
          style={{
            margin: "8px 0px",
            fontSize: "14px",
            fontFamily: "DM Sans",
            borderRadius: "8px",
            color: colors.textBlue,
            background: selected === option.value ? "#EDE9FE" : "transparent",
            fontWeight: selected === option.value ? "600" : "400",
          }}
        >
          {option.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default IyugaMenu;
